import { Card, Grid, InputLabel } from "@mui/material";
import MDInput from "components/MDInput";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDSelect from "components/MDSelect";
import { MDTextFieldCalendar } from "components/MDTextFiedCalendar";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import { useUser } from "context/UserContext";
import DataTable from "examples/Tables/DataTable";
import DefaultCell from "layouts/dashboards/sales/components/DefaultCell";
import { useCallback, useEffect, useRef, useState } from "react";
import { toDate } from "utils/DateUtils";
import { cleanFormatCNPJ } from "utils/Functions";
import { post } from "utils/WebService";

export default function CompanyConsult() {

    const [controller] = useMaterialUIController();
    const { darkMode } = controller;
    const { processoStatus } = useUser();


    const tableState = useRef({
        pageSize: 10,
        pageIndex: 0,
        sorting: [],
        filtered: [],
        empresa: "",
        cnpj: "",
        inicioPesquisa: "",
        fimPesquisa: "",
        status: null,
    });

    const [data, setData] = useState([]);
    const [pages, setPages] = useState(0);
    const [loadingTable, setLoadingTable] = useState(true);

    const [filters, setFilters] = useState({
        empresa: "",
        cnpj: "",
        inicioPesquisa: "",
        fimPesquisa: "",
        status: null,
    });
    const [recordsTotal, setRecordsTotal] = useState(0);

    useEffect(() => {
        fetchData({ ...tableState });
    }, []);

    const fetchData = useCallback(({ pageSize, pageIndex, sorting, filtered,
        empresa,
        cnpj,
        inicioPesquisa,
        fimPesquisa,
        status,
    }) => {
        setLoadingTable(true);

        const updatedTableState = {
            pageSize: pageSize ? pageSize : tableState.current.pageSize,
            pageIndex: (pageIndex == 0 || pageIndex) ? pageIndex : tableState.current.pageIndex,
            sorting: sorting ? sorting : tableState.current.sorting,
            filtered: filtered ? filtered : tableState.current.filtered,
            empresa: empresa ? empresa : tableState.current.empresa,
            cnpj: cnpj ? cnpj : tableState.current.cnpj,
            inicioPesquisa: inicioPesquisa ? inicioPesquisa : tableState.current.inicioPesquisa,
            fimPesquisa: fimPesquisa ? fimPesquisa : tableState.current.fimPesquisa,
            status: status ? status : tableState.current.status,
        };

        tableState.current = updatedTableState;
        post("/company/list", {
            page: updatedTableState.pageIndex,
            pageSize: updatedTableState.pageSize,
            sorted: updatedTableState.sorting,
            filtered: [],
            empresa: updatedTableState.empresa,
            cnpj: updatedTableState.cnpj,
            inicioPesquisa: updatedTableState.inicioPesquisa,
            fimPesquisa: updatedTableState.fimPesquisa,
            status: updatedTableState.status,
        }).then(({ data, pages, recordsTotal }) => {
            setPages(pages);
            setData(data);
            setRecordsTotal(recordsTotal);
            setLoadingTable(false);
        }).catch(() => setLoadingTable(false));

    }, []);


    const userColumns = [
        {
            header: "empresa",
            accessorKey: "empresa",
            cell: info => <DefaultCell>{info.getValue() || '-'}</DefaultCell>,
            isSorted: true
        },
        {
            header: "cnpj",
            accessorKey: "cnpj",
            cell: info => <DefaultCell>{info.getValue() || '-'}</DefaultCell>,
            isSorted: true
        },
        {
            header: "Data Pesquisa",
            accessorKey: "dataPesquisa",
            cell: info => <DefaultCell>{toDate(info.getValue()) || '-'}</DefaultCell>,
            isSorted: true
        },
        {
            header: "Status",
            accessorKey: "status",
            cell: info => <DefaultCell>{processoStatus.find(ht => ht.code === info.getValue())?.name || "-"}</DefaultCell>,
            isSorted: true
        }
    ];

    const handleApplyFilter = () => {
        fetchData({
            ...tableState,
            empresa: filters.empresa,
            cnpj: cleanFormatCNPJ(filters.cnpj),
            inicioPesquisa: filters.inicioPesquisa,
            fimPesquisa: filters.fimPesquisa,
            status: filters.status?.id
        });
    };

    const handleCleanFilter = () => {
        setFilters({
            empresa: "",
            cnpj: "",
            inicioPesquisa: "",
            fimPesquisa: "",
            status: null,
        });
        const updatedTableState = {
            pageSize: 10,
            pageIndex: 0,
            sorting: [],
            filtered: [],
            empresa: "",
            cnpj: "",
            inicioPesquisa: "",
            fimPesquisa: "",
            status: null,
        };

        tableState.current = updatedTableState;
        fetchData(updatedTableState);
    };

    return (
        <Grid container display="flex" justifyContent="center">
            <Grid item xs={12} md={12}>
                <Card
                    variant="outlined"
                    sx={{
                        px: 2,
                        py: 1.5,
                        mb: 2,
                        background: darkMode ? "#23233a" : "#fafafa",
                        borderColor: darkMode ? "#333" : "#ddd",
                    }}
                >
                    <Grid container spacing={1}>
                            <Grid item xs={3} sm={4}>
                                <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Empresa</InputLabel>
                                <MDInput
                                    size="small"
                                    placeholder="Informe a empresa..."
                                    value={filters.empresa}
                                    onChange={({ target }) => setFilters({ ...filters, empresa: target.value })}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            handleApplyFilter();
                                        }
                                    }}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={3} sm={4}>
                                <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>CNPJ</InputLabel>
                                <MDInput
                                    size="small"
                                    placeholder="Informe o cnpj..."
                                    value={filters.cnpj}
                                    onChange={({ target }) => setFilters({ ...filters, cnpj: target.value })}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            handleApplyFilter();
                                        }
                                    }}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Status</InputLabel>
                                <MDSelect
                                    isMulti={false}
                                    getOptionValue={(option) => option.code}
                                    getOptionLabel={(option) => option.name}
                                    name="status"
                                    placeholder="Ambos"
                                    value={filters.status || null}
                                    options={processoStatus}
                                    onChange={(value) => {
                                        setFilters({ ...filters, status: value })
                                    }}
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Início Pesquisa</InputLabel>
                                <MDTextFieldCalendar
                                    size="small"
                                    type="date"
                                    value={filters.inicioPesquisa || ""}
                                    fullWidth
                                    onChange={({ target }) => setFilters({ ...filters, inicioPesquisa: target.value })}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    darkMode={darkMode}
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Fim Pesquisa</InputLabel>
                                <MDTextFieldCalendar
                                    size="small"
                                    type="date"
                                    value={filters.fimPesquisa || ""}
                                    fullWidth
                                    onChange={({ target }) => setFilters({ ...filters, fimPesquisa: target.value })}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    darkMode={darkMode}
                                />
                            </Grid>
                            <Grid item xs={12} display="flex" alignItems="center" justifyContent="end" pt={1}>
                                <MDBox>
                                    <MDButton
                                        size="medium"
                                        sx={{ marginRight: 2 }}
                                        variant="contained"
                                        color="info"
                                        circular={false}
                                        iconOnly={false}
                                        onClick={handleCleanFilter}>
                                        Limpar filtro
                                    </MDButton>
                                    <MDButton size="medium" variant="contained" color="info" circular={false} iconOnly={false} onClick={handleApplyFilter}>
                                        Aplicar filtro
                                    </MDButton>
                                </MDBox>
                            </Grid>
                    </Grid>
                </Card>
                <DataTable
                    loading={loadingTable}
                    columnData={userColumns}
                    data={data}
                    fetchData={fetchData}
                    totalPages={pages}
                    totalRecords={recordsTotal}
                    tableState={tableState} />
            </Grid>
        </Grid >
    );
}
